"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;
const react_1 = __importDefault(require("react"));
const react_big_calendar_1 = require("react-big-calendar");
const moment_1 = __importDefault(require("moment"));
require("react-big-calendar/lib/css/react-big-calendar.css");
const localizer = (0, react_big_calendar_1.momentLocalizer)(moment_1.default);
const Calendar = _ref => {
  let views = _ref.views,
    events = _ref.events,
    onHandleSelectEvent = _ref.onHandleSelectEvent,
    eventStyleGetter = _ref.eventStyleGetter,
    scrollToTime = _ref.scrollToTime,
    components = _ref.components,
    date = _ref.date,
    onNavigate = _ref.onNavigate;
  return react_1.default.createElement(react_big_calendar_1.Calendar, {
    selectable: true,
    popup: true,
    localizer: localizer,
    views: views,
    events: events,
    defaultView: "month",
    scrollToTime: scrollToTime || new Date(1970, 1, 1, 6),
    onSelectEvent: onHandleSelectEvent,
    eventPropGetter: eventStyleGetter,
    components: components,
    date: date,
    onNavigate: onNavigate
  });
};
exports.Calendar = Calendar;
exports.default = exports.Calendar;